<template>
<div>
    <div class="card-grid-item" style="cursor: default;" v-if="!loading">
        <div class="panel mar-no">
            <div class="panel-heading">
                <h2 class="panel-title library-card-panel-title"><i class="text-center fa fa-tasks"></i> <span>ATTIVITA' RECENTI</span></h2>
            </div>
            <div class="panel-body addScroll">
                <div class="row" v-for="(log,k) in logs" :key="k" :log="log">
                    <div class="col-xs-1 col-sm-1 col-md-1"><i  v-bind:class="[logClass(log['edittype']), 'pull-left']"></i></div>
                    <div class="col-xs-6 col-sm-6 col-md-6"><span class="pull-left">  {{(!log["resourcedisplayname"] || log["resourcedisplayname"]==="")?"'Non presente'":log["resourcedisplayname"]}}</span></div>
                    <div class="col-xs-4 col-sm-4 col-md-4 task-date-time"><span class="pull-left">  {{timestampToString(log["timestamp"])}}</span></div>
                    <div class="col-xs-1 col-sm-1 col-md-1"><a style="cursor: pointer" @click="logSelected(log['resourceinstanceid'])" v-show="log['edittype']!=='delete'"><i class="fa fa-arrow-circle-right"></i></a></div>
                    <hr/>
                </div>
            </div>
            <div class="panel-footer">
                <div class="row">
                   
                </div>
            </div>
        </div>
    </div>
     <div class="card-grid-item report-modal" v-else>
         <div class="block">
            <p class="circle">
                <span class="ouro ouro3">
                    <span class="left"><span class="anim"></span></span>
                    <span class="right"><span class="anim"></span></span>
                </span>
            </p>
         </div>
    </div>
</div>
</template>
<script>

export default {
    name: 'EditLogsPanel',
    components: {
    },
    props: {
        api: null,
        config: null
    },
    data: function () {
        return {
            logs: {type: Array, value: []},
            loading: false

        }
    },
    methods: {
        search: function() {
            this.load(true);
            this.api.getRecentEditsLogs().then((response) => {
                this.logs = response.data;
                this.load(false);
            },
            (error) => {
                console.log(error);
                this.load(false);
                });
        },
        logSelected: function(value) {
            console.log(value);
            let log_id = value;
            window.open(`/resource/${log_id}`,'_blank');
        },
        logClass: function(value) {
            switch(value) {
                case 'create':
                    return 'fa fa-user-plus';
                case 'delete':
                    return 'fa fa-trash';
                default:
                    return 'fa fa-edit';
            }
        },
        timestampToString(value) {
            let date = "";
            if(value && value!==undefined && value!=="")  {
                try {
                   date = new Date(value); 
                } catch (error) {
                    return "";
                }
            } else {
                return "";
            }
            return date.toLocaleString();
        },
        load(value) {
            this.loading = value;
        }
    },
    created: function() {
        this.search();
    }
}
</script>

<style scoped>
    .card-grid-item {
        width: 100%;
        text-overflow: ellipsis;
        word-wrap: break-word;
        padding-bottom: 0px;
        min-width: 340px;
   }
    .car-grid-item * {
        display: block;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .panel-body {
        min-height: 251px;
    }

    .panel .panel-footer {
        min-height: 53px;
    }

   .addScroll{
    overflow-y:auto;
    height: 200px;
    }

    .card-grid-item.report-modal {
        min-height: 355px;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.1);
        text-align:center;
        display:table; 
        width:420px;
    }

    #app .block {
        display: table-cell; 
        vertical-align:middle;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .task-date-time {
        font-size: 10px;
    }

    @media only screen and (max-device-width: 480px) {
    
        .card-grid-item {
            width: unset;
            min-width: 320px;
        }
    
        .card-grid-item.report-modal {

            min-width: 320px;
            width: unset;

            }
        
        #app > div > div.content-panel > div > div {
            flex-direction: column;
        }

    }
</style>

